var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { resolveContent } from './helpers';
import { avatarContentStyle, avatarStyle } from './styles';
function Avatar(_a) {
    var { content, contentFill = false, size = 'medium', variant = 'navy' } = _a, restProps = __rest(_a, ["content", "contentFill", "size", "variant"]);
    return (_jsx("div", Object.assign({ css: avatarStyle({ contentFill, size, variant }) }, restProps, { children: _jsx("div", Object.assign({ css: avatarContentStyle({
                content,
                contentFill,
                size,
            }) }, { children: resolveContent(content) })) })));
}
export default Avatar;
